import dompurify from "dompurify";
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";
import { Document } from "@contentful/rich-text-types";

export const convertToPlainTextString = (
  document?: Document | string,
): string | undefined => {
  if (!document) return undefined;

  if (typeof document === "string") {
    return dompurify.sanitize(document, {
      FORBID_TAGS: ["p", "u", "b"],
    });
  }
  
  return dompurify.sanitize(documentToPlainTextString(document));
};
